<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Members</li>
    </ol>
</nav>

<div class="row">
    <div class="col-xl-12">
        <app-card cardTitle="" [options]="false" blockClass="table-border-style">
            <div class="row align-items-center gx-2 gy-2">

                <!-- Page Title -->
                <div class="col-12 col-md-6 col-lg-6">
                    <h5 class="mb-0 text-dark fw-bold">Members</h5>
                </div>

                <!-- Actions: Add Button + Date Filter -->
                <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-md-end flex-wrap align-items-center gap-2">

                    <!-- Add Button -->
                    @if (userDataService?.roleMatch(['MEMBER-ADD'])) {
                    <button type="button"
                        class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                        style="width: 25px; height: 25px;" routerLink="/members/add">
                        <mat-icon fontIcon="add"></mat-icon>
                    </button>
                    }

                    <!-- Date Filter -->
                    <mat-form-field appearance="fill" class="m-0" style="min-width: 240px;" (click)="picker.open()">
                        <mat-label>Filter by Added Date</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start Date" [(ngModel)]="sampleSearch.startdate"
                                readonly />
                            <input matEndDate placeholder="End Date" [(ngModel)]="sampleSearch.enddate"
                                (dateChange)="getAllSamples(null)" readonly />
                        </mat-date-range-input>
                        <div matSuffix class="d-flex align-items-center gap-1">
                            @if (sampleSearch.startdate || sampleSearch.enddate) {
                            <mat-icon (click)="clearDateRange()" class="clear-icon"
                                style="cursor: pointer;">close</mat-icon>
                            } @else {
                            <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                            }
                        </div>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>

                </div>
            </div>

            <hr class="m-0 p-0">
            <hr class="m-0 p-0">

            <!-- Filter Row -->
            <div class="row align-items-end">

                <!-- Sample Name Filter -->
                <div class="col-12 col-sm-6 col-lg-2">
                    <mat-form-field class="dense w-100">
                        <mat-label>Search by Reg No/Name</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>


                <!-- Company Filter (only for non-company users) -->
                <div class="col-12 col-sm-6 col-lg-2">
                    <ng-select [items]="wardData" [disabled]="userType===2" bindLabel="name" bindValue="_id"
                        placeholder="Select Ward" [(ngModel)]="sampleSearch.company" name="company"
                        (change)="sampleFilter($event)">
                    </ng-select>
                </div>


                <div class="col-12 col-sm-6 col-lg-2">
                    <ng-select [items]="genderData" bindLabel="name" bindValue="id" placeholder="Select Gender"
                        [(ngModel)]="sampleSearch.gender" name="company" (change)="sampleFilter($event)">
                    </ng-select>
                </div>

                <!-- Category Filter -->
                <div class="col-12 col-sm-6 col-lg-2">
                    <ng-select [items]="categories" bindLabel="name" bindValue="_id" placeholder="Select Category"
                        [(ngModel)]="sampleSearch.category" name="category" (change)="sampleFilter($event)">
                    </ng-select>
                </div>

                <!-- Home/Hospital Filter -->
                <!-- <div class="col-12 col-sm-6 col-lg-1">
                    <ng-select [items]="homeData" bindLabel="name" bindValue="id" placeholder="Home/Hospital"
                        [(ngModel)]="sampleSearch.isHome" name="ishome" (change)="sampleFilter($event)">
                    </ng-select>
                </div> -->

                <!-- Case Closure Filter -->
                <div class="col-12 col-sm-6 col-lg-2">
                    <ng-select [items]="closeType" bindLabel="name" bindValue="id" placeholder="Case Closure"
                        [(ngModel)]="sampleSearch.closeType" name="closeType" (change)="sampleFilter($event)">
                    </ng-select>
                </div>

                <!-- Current Status Filter -->
                <div class="col-12 col-sm-6 col-lg-2">
                    <ng-select [items]="currentStatusData" bindLabel="name" bindValue="id" placeholder="Current Status"
                        [(ngModel)]="sampleSearch.currentStatus" name="currentStatus" (change)="sampleFilter($event)">
                    </ng-select>
                </div>
            </div>

            <!-- Sample Table -->
            <h6 class="my-2 text-primary fw-bold">{{ sampleSearch.isShowDischage ? 'Total Discharged Members' : 'Total Members Exist' }}: <strong>{{total}}</strong></h6>

            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered compact-table">
                        <!-- Position Column -->
                        <ng-container matColumnDef="srno">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let index = index">
                                {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="company">
                            <th mat-header-cell *matHeaderCellDef>Image </th>
                            <td mat-cell *matCellDef="let element" class="">
                                <!-- {{ element.companyId?.name }} -->
                                <img [src]="getImg(element.face_image)" class="rounded-circle logo-img" alt=""
                                    [title]="element.name ">

                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Name </th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex align-items-center gap-2">
                                    <!-- Image on the left -->
                                    <a [href]="getImg(element.face_image || getImg(element.regImage))" target="_blank">
                                    <img [src]="getImg(element.face_image || getImg(element.regImage))" class="rounded-circle logo-img" alt="https://static.vecteezy.com/system/resources/thumbnails/028/569/170/small_2x/single-man-icon-people-icon-user-profile-symbol-person-symbol-businessman-stock-vector.jpg"
                                        (error)="setDefaultImage($event)" [title]="element.name ">
                                    </a>
                                    <!-- Name + Category on the right -->
                                    <div>
                                        <div class="fw-bold " (click)="openModel(element._id)" style="cursor: pointer;">
                                            {{ element.name }}</div>
                                        <small class="text-muted fs-7">{{ element.regNo }}</small>
                                    </div>
                                </div>
                            </td>

                        </ng-container>
                        <ng-container matColumnDef="barcode">
                            <th mat-header-cell *matHeaderCellDef> Gender </th>
                            <td mat-cell *matCellDef="let element"> {{ (element?.gender) === 0 ? '-' : (element?.gender
                                === 1 ? 'Male'
                                : (element?.gender === 2 ? 'Female' : '')) }} </td>
                        </ng-container>

                        <ng-container matColumnDef="totalItems">
                            <th mat-header-cell *matHeaderCellDef>Ward </th>
                            <td mat-cell *matCellDef="let element"> {{element.wardId?.name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="requestWardStatus">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap">Req Ward & Status </th>
                            <td mat-cell *matCellDef="let element"> 
                                <span *ngIf="element.wardChangeRequestStatus">
                                    {{element.wardChangeRequestId?.toWardId?.name || 'Not Specified'}}
                                </span>
                                <br *ngIf="element.wardChangeRequestStatus">
                                <span *ngIf="element.wardChangeRequestStatus" class="badge" 
                                    [ngClass]="{
                                        'bg-warning': element.wardChangeRequestStatus === 'Pending',
                                        'bg-success': element.wardChangeRequestStatus === 'Accepted',
                                        'bg-danger': element.wardChangeRequestStatus === 'Rejected'
                                    }">
                                    {{element.wardChangeRequestStatus}}
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="leftItems">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element">
                                <!-- {{element?.isAdmit===0?"-":(element?.isAdmit===1)?"Admit":"Discharged"}} <br> {{element.isAdmit}}</td> -->
                                 {{ element?.currentStatus || (element?.isAdmit === 0 ? "-" : (element?.isAdmit === 1 ? "Admit" : "Discharged")) }} <br> {{element.isAdmit}}
                        </ng-container>

                        <ng-container matColumnDef="ageRange">
                            <th mat-header-cell *matHeaderCellDef> Age Range (Years)</th>
                            <td mat-cell *matCellDef="let element"> {{element.ageRange}} </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let element">
                                {{
                                  (element?.currentStatus) || ((element?.closeType === 0) ? "Live" :
                                (element?.closeType === 1) ? "Death" :
                                (element?.closeType === 2) ? "Family Reunite" :
                                (element?.closeType === 3) ? "Escape" :
                                (element?.closeType === 4) ? "NGO family member" :
                                "")
                                }}
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef class="text-nowrap"> Added On </th>
                            <td mat-cell *matCellDef="let element">

                                {{ element.createdAt | date:'dd/MM/yyyy' }}<br>
                                <small>{{ element.createdAt | date:'hh:mm a' }}</small> <br>
                                {{element?.addedUser}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="isBlocked">
                            <th mat-header-cell *matHeaderCellDef class="text-center"> Status </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <ng-toggle [value]="!element.isBlocked"
                                    [color]="{ unchecked: '#939da2', checked: '#BC5C1C' }"
                                    (click)="sampleStatus(element)" [width]="30" [height]="15">
                                </ng-toggle>
                            </td>
                        </ng-container>




                        <ng-container matColumnDef="preview" stickyEnd>
                            <th mat-header-cell *matHeaderCellDef class="text-center sticky-action-col"> Actions </th>
                            <td mat-cell *matCellDef="let element" class="text-center sticky-action-col">
                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">

                                    <mat-icon matTooltip="View Members" matTooltipPosition="left" title="View"
                                        *appHasRole="['MEMBER-VIEW']" aria-hidden="false" aria-label="visibility icon"
                                        fontIcon="visibility" class="c_btn"
                                        [routerLink]="['/member/view', element._id]">
                                    </mat-icon>

                                    <mat-icon matTooltip="Add Treatment" matTooltipPosition="left" title="Add Treatment"
                                        *appHasRole="['MEMBER-ADD-TREATMENT']" aria-hidden="false"
                                        aria-label="local_hospital icon" fontIcon="local_hospital" class="c_btn"
                                        (click)="openModalAddTreatment(element._id)">
                                    </mat-icon>

                                    <!-- <mat-icon matTooltip="Add Medical Test" matTooltipPosition="left" fontIcon="medical_services" class="c_btn"
                                              (click)="openMedicalTestModal(element._id)">
                                            </mat-icon> -->
                                    <mat-icon matTooltip="Add Medical Test" *appHasRole="['MEDICAL-TEST-ADD']" aria-hidden="false" aria-label="medical_services icon"
                                        matTooltipPosition="left" fontIcon="healing" class="c_btn"
                                        (click)="openADDmedicalTestModal(element._id)">
                                    </mat-icon>

                                    <mat-icon matTooltip="Category Change" matTooltipPosition="left"
                                        title="Category Change" *appHasRole="['CATEGORY-CHANGE']" aria-hidden="false"
                                        aria-label="track_changes icon" fontIcon="track_changes" class="c_btn"
                                        (click)="openModalAddCategoryChange(element._id,element?.categoryId?._id)">
                                    </mat-icon>

                                    <mat-icon matTooltip="Ward Change" matTooltipPosition="left" title="Ward Change"
                                        *appHasRole="['WARD-CHANGE']" aria-hidden="false" aria-label="meeting_room icon"
                                        fontIcon="meeting_room" class="c_btn"
                                        (click)="openModalAddWardChange(element._id,element?.wardId?._id)">
                                    </mat-icon>

                                    <mat-icon matTooltip="Edit Members" matTooltipPosition="left" title="Edit"
                                        *appHasRole="['MEMBER-EDIT']" aria-hidden="false" aria-label="edit icon"
                                        fontIcon="edit" class="c_btn" [routerLink]="['/members/edit',element?._id]">
                                    </mat-icon>
                                    <ng-container *ngIf="(element?.closType!==0) && (element?.isAdmit===1)">
                                        <mat-icon matTooltip="Discharge Person" matTooltipPosition="left"
                                            *appHasRole="['MEMBER-DISCHARGE']" aria-hidden="false"
                                            aria-label="check_circle icon" fontIcon="check_circle" class="c_btn"
                                            (click)="openModalAddDischarge(element._id)">
                                        </mat-icon>
                                    </ng-container>
                                </div>
                            </td>
                        </ng-container>

                        @if(userDataService?.roleMatch(['MEMBERS-EDIT'])){
                        <ng-container matColumnDef="action" stickyEnd>
                            <th mat-header-cell *matHeaderCellDef class="text-center sticky-action-col"> Action </th>
                            <td mat-cell *matCellDef="let element" class="text-center sticky-action-col">

                                <div class="d-flex align-items-center gap-1 justify-content-center flex-nowrap">
                                    <mat-icon aria-hidden="false" aria-label="Edit icon" fontIcon="edit" class="c_btn"
                                        [routerLink]="['/members/edit',element._id]"></mat-icon>
                                </div>
                            </td>
                        </ng-container>
                        }



                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                No data available
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <mat-paginator #paginator [length]="total" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllSamples($event)">
            </mat-paginator>

        </app-card>
    </div>
</div>

<!---- detail -->
<div class="modal fade" id="sampleDetailModal" tabindex="-1" aria-labelledby="sampleDetailModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 rounded-3 overflow-hidden">
            <div class="modal-header border-0 p-2">
                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>

            <div class="container-fluid p-0">
                <div class="card border-0 rounded-0">
                    <!-- Header Section -->
                    <div class="card-header bg-gradient-primary text-white p-3">
                        <div class="d-flex flex-wrap justify-content-between align-items-start">
                            <div>
                                <h5 class="fw-semibold text-dark mb-1">{{sampleData?.name}}</h5>
                                <small class="text-dark">{{sampleData?.categoryId.name}}</small>
                                <div class="d-flex flex-wrap gap-2 mt-1">
                                    @if (sampleData?.sampleCode) {
                                    <span class="fw-bold text-dark">{{ getSampleCode(sampleData.sampleCode) }}</span>
                                    <svg #barcodeElement></svg>
                                    }

                                </div>
                            </div>
                            <div class="text-end text-dark small">
                                @if (sampleData?.companyId?.name) {
                                <div><strong>Added by:</strong> {{sampleData.companyId.name}}</div>
                                }
                                @if (sampleData?.createdAt) {
                                <div><strong>Created:</strong> {{sampleData.createdAt | date}}</div>
                                }
                            </div>
                        </div>
                    </div>

                    <!-- Body Section -->
                    <div class="card-body p-3">
                        <div class="row g-3">
                            <!-- Images Gallery -->
                            <div class="col-md-4">
                                @if (sampleData?.sampleImages?.length) {
                                <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
                                    <div class="carousel-inner rounded">
                                        @for (image of sampleData.sampleImages; track image; let i = $index) {
                                        <div class="carousel-item" [class.active]="i === 0">
                                            <img [src]="getImg(image)" class="d-block w-100 img-fluid"
                                                style="height: 300px; object-fit: cover;" alt="Sample Image">
                                        </div>
                                        }
                                    </div>
                                    <button class="carousel-control-prev" type="button"
                                        data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon bg-dark rounded-circle p-2"></span>
                                        <span class="visually-hidden">Previous</span>
                                    </button>
                                    <button class="carousel-control-next" type="button"
                                        data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                                        <span class="carousel-control-next-icon bg-dark rounded-circle p-2"></span>
                                        <span class="visually-hidden">Next</span>
                                    </button>
                                </div>
                                } @else {
                                <div class="bg-light rounded d-flex align-items-center justify-content-center"
                                    style="height: 300px;">
                                    <p class="text-muted mb-0">No images available</p>
                                </div>
                                }

                                @if (sampleData?.videoLink) {
                                <div class="mt-3">
                                    <h6 class="fw-bold mb-2">{{sampleData.videoTitle??"Product Video"}}</h6>
                                    <div class="ratio ratio-16x9">
                                        <iframe [src]="sampleData.videoLink | safeUrl" frameborder="0"
                                            allowfullscreen></iframe>
                                    </div>
                                </div>
                                }
                            </div>

                            <!-- Details Section -->
                            <div class="col-md-7">
                                <!-- Inventory Status -->
                                <div class="row text-center mb-3">
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Total</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.totalItems || 0}}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Available</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.leftItems || 0}}</span>
                                    </div>
                                    <div class="col-4">
                                        <small class="text-dark fw-semibold d-block">Assigned</small>
                                        <span class="fw-bold fs-5 text-dark">{{sampleData?.assignedItems || 0}}</span>
                                    </div>
                                </div>

                                <!-- Product Details -->
                                <div class="mb-3">
                                    <h6 class="fw-bold border-bottom pb-1">Product Details</h6>

                                    @if (sampleData?.description) {
                                    <div><small class="fw-bold">Description:</small>
                                        <div [innerHTML]="sampleData.description"></div>
                                    </div>
                                    }
                                    @if (sampleData?.aboutSample) {
                                    <div><small class="fw-bold">About Sample:</small>
                                        <div [innerHTML]="sampleData.aboutSample"></div>
                                    </div>
                                    }
                                    @if (sampleData?.ingredients) {
                                    <div><small class="fw-bold">Ingredients:</small>
                                        <div [innerHTML]="sampleData.ingredients"></div>
                                    </div>
                                    }

                                    @if (sampleData?.usageInstructions) {
                                    <div><small class="fw-bold">Usage:</small>
                                        <div [innerHTML]="sampleData.usageInstructions"></div>
                                    </div>
                                    }
                                </div>

                                <!-- Issue Limits -->
                                <div>
                                    <h6 class="fw-bold border-bottom pb-1">Issue Limits</h6>
                                    <div class="row text-center">
                                        <div class="col-4">
                                            <small class="text-muted d-block">Customer</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityCustomer ||
                                                0}}</span>
                                        </div>
                                        <div class="col-4">
                                            <small class="text-muted d-block">Retailer</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityRetailer ||
                                                0}}</span>
                                        </div>
                                        <div class="col-4">
                                            <small class="text-muted d-block">Wholesaler</small>
                                            <span class="fw-bold text-dark">{{sampleData?.maxIssueQuantityWholesaler ||
                                                0}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="card-footer bg-light d-flex justify-content-between align-items-center p-2">
                        <small class="text-muted">Last updated: {{sampleData?.updatedAt | date}}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Add Treatment Logs -->

<div class="modal fade" id="addTreatmentModal" tabindex="-1" aria-labelledby="addTreatmentModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content border-0 rounded-3">

            <!-- Header -->
            <div class="modal-header py-2 px-3">
                <h6 class="modal-title fw-semibold" id="addTreatmentModalLabel">
                    Add Treatment Remarks
                </h6>
                <button type="button" class="btn-close" (click)="hideAddTreatment()"></button>
            </div>

            <!-- Form Start -->
            <form [formGroup]="addTreatment" (ngSubmit)="submitAddTreatment()">

                <!-- Body -->
                <div class="modal-body py-3 px-3">

                    <div class="mb-3">
                        <label class="form-label small fw-medium">Remarks</label>
                        <textarea rows="4" formControlName="remarks" class="form-control form-control-sm"
                            placeholder="Enter treatment remarks here...">
            </textarea>

                        <!-- Validation Message removed as remarks are optional -->
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Upload PDF</label>
                        <input type="file" class="form-control" accept="application/pdf"
                            (change)="onTreatmentFileChange($event)">
                    </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer py-2 px-3">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="hideAddTreatment()"> Cancel
                    </button>

                    <button type="submit" class="btn btn-primary btn-sm px-4" [disabled]="addTreatment.invalid"> <i
                            class="fas fa-paper-plane me-1"></i> Submit
                    </button>
                </div>
            </form>
            <!-- Form End -->
        </div>
    </div>
</div>



<!-- Add Category Change Logs -->
<div class="modal fade" id="categoryChangeModal" tabindex="-1" aria-labelledby="categoryChangeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content border-0 rounded-3 shadow-sm">

            <!-- Header -->
            <div class="modal-header py-2 px-3">
                <h6 class="modal-title fw-semibold" id="categoryChangeModalLabel">
                    Add Category Change
                </h6>
                <button type="button" class="btn-close" (click)="hideCategoryChange()"></button>
            </div>

            <!-- Form Start -->
            <form [formGroup]="addCategory" (ngSubmit)="submitCategoryChange()">

                <!-- Body -->
                <div class="modal-body py-3 px-3">

                    <!-- Remarks -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">Remarks</label>
                        <textarea rows="4" formControlName="remarks" class="form-control form-control-sm"
                            placeholder="Enter category remarks here...">
            </textarea>

                        <!-- Validation Message removed as remarks are optional -->
                    </div>

                    <!-- Category -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">Choose Category</label>

                        <ng-select [items]="categories" bindLabel="name" bindValue="_id" formControlName="categoryId"
                            placeholder="Select Category" class="ng-select-sm">
                        </ng-select>

                        <div class="text-danger small mt-1"
                            *ngIf="addCategory.get('categoryId')?.touched && addCategory.get('categoryId')?.invalid">
                            Category is required.
                        </div>
                    </div>

                </div>

                <!-- Footer -->
                <div class="modal-footer py-2 px-3">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="hideCategoryChange()">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary btn-sm px-4" [disabled]="addCategory.invalid">
                        <i class="fas fa-paper-plane me-1"></i>
                        Submit
                    </button>
                </div>

            </form>
            <!-- Form End -->

        </div>
    </div>
</div>


<!-- Add Ward Change Logs -->
<div class="modal fade" id="wardChangeModal" tabindex="-1" aria-labelledby="wardChangeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content border-0 rounded-3 shadow-sm">

            <!-- Header -->
            <div class="modal-header py-2 px-3">
                <h6 class="modal-title fw-semibold" id="wardChangeModalLabel">
                    Add Ward Change
                </h6>
                <button type="button" class="btn-close" (click)="hideWardChange()"></button>
            </div>

            <!-- Form Start -->
            <form [formGroup]="addWard" (ngSubmit)="submitWardChange()">

                <!-- Body -->
                <div class="modal-body py-3 px-3">

                    <!-- Remarks -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">
                            Remarks
                        </label>

                        <textarea rows="4" formControlName="remarks" class="form-control form-control-sm"
                            placeholder="Enter ward change remarks here...">
            </textarea>

                        <!-- Validation Message removed as remarks are optional -->
                    </div>

                    <div class="mb-3">
                        <label class="form-label small fw-medium">
                            Volunteer Name <span class="text-danger">*</span>
                        </label>

                        <input type="text" formControlName="volunteerName" class="form-control form-control-sm"
                            placeholder="Enter volunteer name">

                        <div class="text-danger small mt-1"
                            *ngIf="addWard.get('volunteerName')?.touched && addWard.get('volunteerName')?.invalid">
                            Volunteer name is required.
                        </div>
                    </div>

                    <!-- Ward -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">
                            Choose Ward
                        </label>

                        <ng-select [items]="wardData" bindLabel="name" bindValue="_id" formControlName="wardId"
                            placeholder="Select Ward" class="ng-select-sm">
                        </ng-select>

                        <div class="form-text small mt-1 text-muted">
                            Leave empty if you don't know the ward. The Admin will assign it later.
                        </div>
                    </div>

                </div>

                <!-- Footer -->
                <div class="modal-footer py-2 px-3">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="hideWardChange()">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary btn-sm px-4" [disabled]="addWard.invalid">
                        <i class="fas fa-paper-plane me-1"></i>
                        Submit
                    </button>
                </div>

            </form>
            <!-- Form End -->

        </div>
    </div>
</div>


<!-- Close Person Modal -->
<div class="modal fade" id="closePersonModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 rounded-3 shadow-sm">

            <!-- Header -->
            <div class="modal-header py-2 px-3">
                <h6 class="modal-title fw-semibold">Case Closure Case</h6>
                <button type="button" class="btn-close" (click)="hideCloseModal()"></button>
            </div>

            <form [formGroup]="closeForm" (ngSubmit)="submitCloseForm()">

                <div class="modal-body px-3 py-3">

                    <!-- Close Type -->
                    <div class="mb-3">
                        <label class="form-label fw-medium">
                            Case Closure Type <span class="text-danger">*</span>
                        </label>

                        <ng-select [items]="closeTypes" bindLabel="label" bindValue="value" formControlName="closeType"
                            placeholder="Select Close Type">
                        </ng-select>
                    </div>

                    <!-- Remarks -->
                    <div class="mb-3">
                        <label class="form-label fw-medium">
                            Remarks
                        </label>
                        <textarea rows="3" formControlName="remarks" class="form-control form-control-sm"
                            placeholder="Enter remarks">
            </textarea>
                    </div>

                    <div class="mb-3">
                        <label class="form-label fw-medium">
                            Upload Discharge Summary (PDF)
                        </label>

                        <input type="file" class="form-control form-control-sm" accept="application/pdf"
                            (change)="onDischargeFileChange($event)">
                    </div>

                    <!-- If closeType = 4 (NGO Family Member) -->
                    <div *ngIf="(closeForm?.value?.closeType)===4" class="mb-3">
                        <label class="form-label fw-medium">
                            Select Ward <span class="text-danger">*</span>
                        </label>

                        <ng-select [items]="wardData" bindLabel="name" bindValue="_id" formControlName="wardId"
                            placeholder="Select Ward">
                        </ng-select>
                    </div>

                    <!-- If closeType = 2 (Family Reunite) -->
                    <div *ngIf="(closeForm?.value?.closeType)===2" class="row mt-3">

                        <div class="col-md-4 mb-2">
                            <input type="text" formControlName="fname" class="form-control form-control-sm"
                                placeholder="Family Name">
                        </div>

                        <div class="col-md-4 mb-2">
                            <input type="number" formControlName="fphone" class="form-control form-control-sm"
                                placeholder="Family Phone">
                        </div>

                        <div class="col-md-4 mb-2">
                            <input type="number" formControlName="fanotherPhone" class="form-control form-control-sm"
                                placeholder="Another Phone">
                        </div>

                        <div class="col-md-4 mb-2">
                            <input type="text" formControlName="fproofType" class="form-control form-control-sm"
                                placeholder="Proof Type">
                        </div>

                        <div class="col-md-4 mb-2">
                            <input type="text" formControlName="fproofNo" class="form-control form-control-sm"
                                placeholder="Proof No">
                        </div>

                        <div class="col-md-4 mb-2">
                            <input type="text" formControlName="faddress" class="form-control form-control-sm"
                                placeholder="Family Address">
                        </div>

                    </div>

                </div>

                <!-- Footer -->
                <div class="modal-footer py-2 px-3">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="hideCloseModal()">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary btn-sm px-4" [disabled]="closeForm.invalid">
                        Submit
                    </button>
                </div>

            </form>

        </div>
    </div>
</div>

<div class="modal fade" id="ADDmedicalTestModal" tabindex="-1" aria-labelledby="medicalTestModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 rounded-3 shadow-sm">

            <!-- Header -->
            <div class="modal-header py-2 px-3 border-bottom">
                <h5 class="modal-title fw-semibold" id="medicalTestModalLabel">
                    <mat-icon class="me-2" fontIcon="medical_services"></mat-icon>Add Medical Test
                </h5>
                <button type="button" class="btn-close" (click)="hideADDmedicalTestModal()"></button>
            </div>

            <!-- Form Start -->
            <form [formGroup]="medicalTestForm" (ngSubmit)="submitMedicalTest()">

                <!-- Body -->
                <div class="modal-body py-3 px-3">

                    <!-- Test Name -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">
                            Test Name <span class="text-danger">*</span>
                        </label>
                        <input type="text" formControlName="testName" class="form-control form-control-sm"
                            placeholder="Enter test name">
                        <small class="text-danger"
                            *ngIf="medicalTestForm.get('testName')?.touched && medicalTestForm.get('testName')?.invalid">Test
                            name is required</small>
                    </div>

                    <!-- Select Predefined Tests -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">
                            Select Predefined Tests <span class="text-danger">*</span>
                        </label>
                        <ng-select [items]="predefinedTests" bindLabel="name" bindValue="_id"
                            formControlName="selectedTests" placeholder="Search and select tests..." multiple="true"
                            class="ng-select-sm">
                        </ng-select>
                        <small class="text-danger"
                            *ngIf="medicalTestForm.get('selectedTests')?.touched && medicalTestForm.get('selectedTests')?.invalid">Please
                            select at least one test</small>
                    </div>

                    <!-- Other Tests Section -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">Other Tests</label>
                        <div formArrayName="otherTests">
                            <div *ngFor="let test of otherTestsFormArray.controls; let i = index" [formGroupName]="i"
                                class="mb-2 p-2 border rounded">
                                <div class="row">
                                    <div class="col-md-5">
                                        <input type="text" formControlName="name" class="form-control form-control-sm"
                                            placeholder="Test name">
                                        <small class="text-danger"
                                            *ngIf="test.get('name')?.touched && test.get('name')?.invalid">Name
                                            required</small>
                                    </div>
                                    <div class="col-md-5">
                                        <input type="number" formControlName="price"
                                            class="form-control form-control-sm" step="0.01" placeholder="Price"
                                            min="0">
                                        <small class="text-danger"
                                            *ngIf="test.get('price')?.touched && test.get('price')?.invalid">Valid price
                                            required</small>
                                    </div>
                                    <div class="col-md-1">
                                        <button type="button" class="btn btn-sm btn-danger"
                                            (click)="removeOtherTest(i)">
                                            <mat-icon fontIcon="delete"></mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <button type="button"
                                class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                                (click)="addOtherTest()">
                                <mat-icon fontIcon="add"></mat-icon> Add Other Test
                            </button>
                        </div>
                    </div>

                    <!-- Image Upload -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">Upload Images</label>
                        <div class="input-group">
                            <input type="file" id="medicalTestFileInput" (change)="onFileChange($event)" multiple
                                accept="image/*" class="form-control form-control-sm" placeholder="Select images">
                        </div>
                        <small class="text-muted">You can upload multiple images</small>

                        <!-- Image Previews -->
                        <div *ngIf="imagePreviews.length > 0" class="mt-2">
                            <label class="form-label small fw-medium d-block mb-2">Image Previews</label>
                            <div class="d-flex flex-wrap gap-2">
                                <div *ngFor="let preview of imagePreviews; let i = index" class="position-relative"
                                    style="width: 80px; height: 80px;">
                                    <img [src]="preview" class="img-fluid rounded border"
                                        style="width: 100%; height: 100%; object-fit: cover;">
                                    <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0"
                                        style="transform: translate(50%, -50%); padding: 2px 6px;"
                                        (click)="removeImagePreview(i)">
                                        <mat-icon fontIcon="close" class="fs-6"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Remarks -->
                    <div class="mb-3">
                        <label class="form-label small fw-medium">Remarks</label>
                        <textarea rows="3" formControlName="remarks" class="form-control form-control-sm"
                            placeholder="Enter any additional remarks or notes"></textarea>
                    </div>

                </div>

                <!-- Footer -->
                <div class="modal-footer py-2 px-3 border-top">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="hideADDmedicalTestModal()">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary btn-sm px-4" [disabled]="medicalTestForm.invalid">
                        <mat-icon fontIcon="save" class="me-1"></mat-icon>
                        Submit
                    </button>
                </div>

            </form>
            <!-- Form End -->

        </div>
    </div>
</div>